import { createFileRoute, Link } from "@tanstack/react-router";
import { useState } from "react";
import { toast } from "sonner";
import { resetPassword } from "@/lib/auth/authClient";
import { RouteTopBar } from "@/components/layout/RouteTopBar";
import { translateAuthError } from "@/lib/auth/authErrorTranslator";
import { useLanguage } from "@/hooks/useLanguage";

export const Route = createFileRoute("/forgot-password")({
  head: () => ({
    meta: [{ title: "Recuperar contraseña · VerseSport" }],
  }),
  component: ForgotPasswordPage,
});

function ForgotPasswordPage() {
  const { lang, t } = useLanguage();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitting(true);
    try {
      await resetPassword(email.trim().toLowerCase());
      setSent(true);
      toast.success(t("forgot_toast_sent"));
    } catch (err) {
      toast.error(translateAuthError(err, lang));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="min-h-screen bg-background">
      <RouteTopBar fallback="/login" />
      <div className="mx-auto max-w-md px-4 py-8">
        <h1 className="text-2xl font-black text-foreground">{t("forgot_title")}</h1>
        <p className="mt-1 text-sm text-muted-foreground">{t("forgot_desc")}</p>
        {sent ? (
          <div className="mt-6 rounded-lg border border-border bg-accent/10 p-4 text-sm">
            {t("forgot_sent_inbox")} <strong>{email}</strong>.
          </div>
        ) : (
          <form onSubmit={onSubmit} className="mt-6 space-y-4">
            <input type="email" required maxLength={255} value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t("forgot_email_placeholder")} className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm" />
            <button type="submit" disabled={submitting} className="w-full rounded-xl bg-primary px-4 py-3 text-sm font-bold text-primary-foreground shadow disabled:opacity-60">
              {submitting ? "…" : t("forgot_submit")}
            </button>
          </form>
        )}
        <Link to="/login" search={{ from: undefined }} className="mt-6 block text-center text-xs text-muted-foreground hover:text-foreground">{t("forgot_back_login")}</Link>
      </div>
    </main>
  );
}